const InterfaceConstructor = require("../template")
const navigator = new InterfaceConstructor("navigator")

navigator.methods = {
    open: (data = {}) => {
        window.open(data.url, data.target || "_self")
    },
    back: (data = {}) => {
        window.history.back(data.steps || -1)
    },
    reload: () => {
        window.location.reload()
    },
}

module.exports = navigator
